<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>房屋详情</span>
    </div>
    <!-- 顶部swiper部分 -->
    <div class="swiper-content">
      <van-swipe
        ref="swipe"
        @change="swiperIndexChange"
        :show-indicators="false"
        style="height: 350rpx;"
      >
        <van-swipe-item>
          <div class="video-content">
            <video
              id="myVideo"
              :src="roomInfo.video ? roomInfo.video.url : ''"
              :autoplay="true"
              :loop="true"
              :muted="true"
              :controls="false"
              style="width: 100%;height: 100%;"
            ></video>
            <!-- <cover-div style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;z-index: 100;background-color: transparent;"></cover-div> -->
          </div>
        </van-swipe-item>
        <van-swipe-item
          v-for="(item, index) in roomInfo.resourcesResults"
          :key="index"
        >
          <div class="swiper-item" style="height: 100%;">
            <img :src="item.url" mode="" style="width: 100%;height: 100%;" />
          </div>
        </van-swipe-item>
        <van-swipe-item v-if="roomInfo.resourcesResults.length == 0">
          <div class="noImg" style="height: 100%;">
            <span>暂无图片</span>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swiper-item" style="height: 100%;">
            <img
              :src="roomInfo.screenShot ? roomInfo.screenShot.url : ''"
              mode=""
              style="width: 100%;height: 100%;"
            />
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="changeSwiperText">
        <div>
          <span @click="changeMenu(0)" :class="{ activeText: current == 0 }"
            >视频</span
          >
          <span
            @click="changeMenu(1)"
            :class="{
              activeText:
                current >= 1 &&
                current <
                  (roomInfo.resourcesResults.length == 0
                    ? 2
                    : roomInfo.resourcesResults.length + 1),
            }"
            >图片</span
          >
          <span
            @click="
              changeMenu(
                roomInfo.resourcesResults.length == 0
                  ? 2
                  : roomInfo.resourcesResults.length + 1
              )
            "
            :class="{
              activeText:
                current >=
                (roomInfo.resourcesResults.length == 0
                  ? 2
                  : roomInfo.resourcesResults.length + 1),
            }"
            >平面图</span
          >
        </div>
        <div class="changeSwiperNumber">
          ({{ current + 1 }}/{{
            roomInfo.resourcesResults.length == 0
              ? 3
              : roomInfo.resourcesResults.length + 2
          }})
        </div>
      </div>
    </div>
    <!-- 价格信息部分 -->
    <div class="price-info">
      <div>{{ roomInfo.buildName }}-{{ roomInfo.roomNo }}</div>
      <div>
        {{ roomInfo.rentAreaName }}/{{ roomInfo.buildName }}/{{
          roomInfo.floorName
        }}
      </div>
      <div class="price-detail">
        <div class="detail-info">
          <span>{{ roomInfo.recommendPrice * roomInfo.roomArea }}/月</span>
          <span>租金报价</span>
        </div>
        <div class="vertical-line"></div>
        <div class="detail-info">
          <span>压二付一</span>
          <span>付款方式</span>
        </div>
        <div class="vertical-line"></div>
        <div class="detail-info">
          <span>{{ roomInfo.roomArea }}㎡</span>
          <span>租赁面积</span>
        </div>
      </div>
    </div>
    <!-- 房间详细信息部分 -->
    <div class="room-detail">
      <div>
        <span>房间编号：</span>
        <span>{{ roomInfo.roomId }}</span>
      </div>
      <div>
        <span>房间地址：</span>
        <span>{{ roomInfo.roomAddress }}</span>
      </div>
      <div>
        <span>租金面积：</span>
        <span>{{ roomInfo.recommendPrice }}元/平</span>
      </div>
      <div>
        <span>起租期：</span>
        <span>{{ roomInfo.minimumRentPeriod }}个月</span>
      </div>
      <div>
        <span>电梯：</span>
        <span>有电梯</span>
      </div>
      <div>
        <span>工位数量：</span>
        <span>{{ roomInfo.locationNumber }}</span>
      </div>
      <div>
        <span>注册：</span>
        <span>{{ roomInfo.registryFlag == 1 ? "可注册" : "不可注册" }}</span>
      </div>
      <div>
        <span>分割：</span>
        <span>{{ roomInfo.splitFlag == 1 ? "可分割" : "不可分割" }}</span>
      </div>
    </div>
    <!-- 客户经理信息部分 -->
    <div class="manager-info">
      <img src="../assets/propertyImg/manager-icon.png" />
      <div>
        <div>客户经理：{{ roomInfo.principal }}</div>
        <div>联系电话：{{ roomInfo.principalPhone }}</div>
      </div>
    </div>
    <!-- 分享部分 -->
    <div class="contact-method">
      <a-button
        type="primary"
        style="background: #1584FF;box-shadow: 0px 2px 8px 0px #80BCFF;border-radius: 8px;width: 100%;"
        @click="shareBtn"
      >
        分享
      </a-button>
    </div>
  </div>
</template>

<script>
import { roomDetail } from "../axios/property";
export default {
  data() {
    return {
      current: 0,
      roomId: "", // 房屋Id
      roomInfo: {
        resourcesResults: [],
        buildName: "",
        roomNo: "",
        rentAreaName: "",
        floorName: "",
        recommendPrice: "",
        roomArea: "",
        roomAddress: "",
        principal: "",
        principalPhone: "",
      }, // 房屋详情信息
      wxShow: false, // 微信图片弹框
    };
  },
  created() {
	console.log(this.$route.params)
    this.roomId = this.$route.params.obj.id;
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      roomDetail(this.roomId).then((res) => {
        console.log(res);
        for (let i in res.data.data) {
          that.roomInfo[i] = res.data.data[i];
        }
      });
      console.log(this.roomInfo);
    },
    backPage() {
      // 回退到首页
      this.$router.push("/room-list");
    },
    swiperIndexChange(index) {
      // 滑块Index改变
      this.current = index;
      this.$refs.swipe.swipeTo(index);
    },
    changeMenu(index) {
      // 更改swiper菜单项
      console.log(index);
      this.current = index;
      this.$refs.swipe.swipeTo(index);
    },
    shareBtn() {
      // 分享
      console.log(666);
    },
  },
};
</script>

<style scoped>
.main-content {
  background-color: #f9f9f9;
  position: relative;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 顶部swiper轮换部分 */
.swiper-content {
  background-color: #5e99b4;
  position: relative;
}

.video-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.changeSwiperText {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 0.4rem;
  z-index: 300;
}
.changeSwiperText > div:nth-child(1) {
  width: auto;
  display: flex;
  justify-content: center;
  background: #ffffff;
  border-radius: 11px;
  margin-right: auto;
  margin-left: 2.5rem;
}
.changeSwiperText span {
  color: #333333;
  padding: 0.2rem 0.3rem;
  text-align: center;
  line-height: 0.2rem;
  border-radius: 11px;
  font-size: 16px;
  font-family: SourceHanSansCN, SourceHanSansCN-Regular;
}

.changeSwiperText .activeText {
  background: #1484ff;
  color: white;
}

.changeSwiperText .changeSwiperNumber {
  width: 1.3rem;
  height: 0.6rem;
  background: #000000;
  border-radius: 11px;
  line-height: 0.6rem;
  text-align: center;
  opacity: 0.8;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  align-self: flex-end;
  margin-top: 0.05rem;
  margin-right: 0.6rem;
}

/* 价格信息部分 */
.price-info {
  padding: 0.5rem;
  background-color: #fff;
}

.price-info > div:nth-child(1) {
  font-size: 0.3rem;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
}

.price-info > div:nth-child(2) {
  font-size: 0.2rem;
  font-family: PingFangSC, PingFangSC-Semibold;
  color: #333333;
  margin-top: 0.1rem;
}

.price-info .price-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.2rem;
}

.price-detail .detail-info {
  display: flex;
  flex-direction: column;
}

.detail-info span:nth-child(1) {
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  font-size: 0.5rem;
  color: #fe5208;
}

.detail-info span:nth-child(2) {
  font-size: 0.3rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #808080;
  margin-top: 0.1rem;
}

.price-detail .vertical-line {
  width: 0.1rem;
  height: 0.82rem;
  border: 1px solid #eff2f5;
}

/* 房间详细信息部分 */
.room-detail {
  margin-top: 0.3rem;
  background-color: #fff;
  padding: 0.5rem;
  line-height: 0.7rem;
}

.room-detail div {
  font-size: 0.4rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #666666;
}

/* 客户经理信息部分 */
.manager-info {
  display: flex;
  height: 1.5rem;
  background: #ffffff;
  align-items: center;
  margin-top: 0.3rem;
}

.manager-info img {
  width: 1.4rem;
  height: 1.2rem;
  margin-left: 0.4rem;
  margin-right: 0.2rem;
}

.manager-info > div div:nth-child(1) {
  font-size: 0.4rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
}

.manager-info > div div:nth-child(2) {
  font-size: 0.3rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #666;
  margin-top: 0.15rem;
}

/* 联系方式部分 */
.contact-method {
  display: flex;
  background: #ffffff;
  align-items: center;
  margin-top: 0.3rem;
  justify-content: center;
  padding: 0.3rem 0.4rem;
}
.contact-method /deep/.ant-btn{
	height:1.1rem
}
</style>
